import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import RouteSheetHeader from './RouteSheetHeader';
import RouteSheetBody from './RouteSheetBody';
import { SUMMARY_REPORT_MODE_TYPE } from '../PrintSummaryReport';
import {
  SUMMARY_PRINT_REPORT_VALUE,
  DETAILED_PRINT_REPORT_VALUE,
} from '../../reducers/report';

const RouteSheet = ({ reportType, data, addressMap, header, mode }) => {
  const {
    objectName,
    plateNumber,
    startTime,
    endTime,
    mileageStart,
    mileageEnd,
    totalWorkHours,
    totalRestHours,
    totalDistance,
  } = header;
  return (
    <Box px={2}>
      <RouteSheetHeader
        objectName={objectName}
        plateNumber={plateNumber}
        startTime={startTime}
        endTime={endTime}
        mileageStart={mileageStart}
        mileageEnd={mileageEnd}
        totalRestHours={totalWorkHours}
        totalWorkHours={totalRestHours}
        totalDistance={totalDistance}
      />
      <RouteSheetBody
        data={data}
        addressMap={addressMap}
        reportType={reportType}
        mode={mode}
      />
    </Box>
  );
};

RouteSheet.propTypes = {
  data: PropTypes.object,
  addressMap: PropTypes.object,
  reportType: PropTypes.oneOf([
    SUMMARY_PRINT_REPORT_VALUE,
    DETAILED_PRINT_REPORT_VALUE,
  ]),
  header: PropTypes.shape({
    objectName: PropTypes.string,
    plateNumber: PropTypes.string,
    startTime: PropTypes.string,
    endTime: PropTypes.string,
    mileageStart: PropTypes.number,
    mileageEnd: PropTypes.number,
    totalWorkHours: PropTypes.string,
    totalRestHours: PropTypes.string,
    totalDistance: PropTypes.number,
  }),
  mode: SUMMARY_REPORT_MODE_TYPE,
};

export default RouteSheet;
